import React from 'react';
export function Footer() {
  return <footer className="bg-[#0F2347] py-8 md:py-10 text-white/60" data-id="element-49">
      <div className="container mx-auto px-4 text-center" data-id="element-50">
        <h2 className="text-white font-poppins font-bold text-2xl mb-4" data-id="element-51">
          🚨 CÓDIGO EMERGENCIA ESCOLAR™
        </h2>

        <p className="max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed" data-id="element-52">
          El sistema N°1 de prevención y acción para escuelas primarias
          argentinas. Herramientas concretas para una educación más segura y
          conectada.
        </p>

        <div className="flex flex-wrap justify-center gap-5 md:gap-8 mb-6 md:mb-8 text-sm font-medium" data-id="element-53">
          <a href="#" className="hover:text-white transition-colors" data-id="element-54">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-55">
            Políticas de Privacidad
          </a>
          <a href="mailto:contacto@codigoemergenciaescolar.com.ar" className="hover:text-white transition-colors" data-id="element-56">
            Soporte
          </a>
        </div>

        <div className="w-full h-px bg-white/10 mb-5" data-id="element-57"></div>

        <p className="text-xs" data-id="element-58">
          © 2026 CÓDIGO EMERGENCIA ESCOLAR™. Todos los derechos reservados.
        </p>
        <p className="text-white font-bold mt-3" data-id="element-59">
          "Tu escuela puede estar preparada desde hoy." 🇦🇷
        </p>
      </div>
    </footer>;
}